import axios from 'axios'
import { push } from 'react-router-redux'
import { Api } from './consts'
export const GET_SESSION = 'auth/GET_USER'
export const LOGIN = 'auth/LOGIN'
export const INCORRECT_CREDENTIALS = 'auth/INCORRECT_PASSWORD'

const initialState = {
  user: {},
  message: null,
  loggedIn: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SESSION:
      return {
        ...state,
        loggedIn: true
      }
    case LOGIN:
      return {
        ...state,
        message: null,
        loggedIn: true
      }
    case INCORRECT_CREDENTIALS:
      return {
        ...state,
        message: 'Incorrect username or password.',
        loggedIn: false
      }
    default:
      return state
  }
}

const setLocalStorage = user => {
    axios.defaults.headers.common['auth'] = user.token
    localStorage.setItem('loggedIn', true)
    localStorage.setItem('username', user.username)
    localStorage.setItem('token', user.token)
}

const unsetLocalStorage = () => {
    axios.defaults.headers.common['auth'] = null
    localStorage.removeItem('username')
    localStorage.removeItem('loggedIn')
    localStorage.removeItem('token')
}

export const getSession = (callback) => {
  return function(dispatch) {
    axios.post(`${Api}/session`, {token: localStorage.getItem('token')})
         .then((response) => {
             setLocalStorage(response.data)
             dispatch({type: GET_SESSION})
         })
         .catch((err) => {
             unsetLocalStorage()
             dispatch(push(`/login`))
    })
  }
}

export const login = user => {
  return function(dispatch) {
    axios.post(`${Api}/login`, user)
         .then((response) => {
           if(response.data.case) {
             dispatch({type: INCORRECT_CREDENTIALS})
           } else {
             setLocalStorage(response.data)
             dispatch({type: LOGIN})
             dispatch(push(`/music`))
           }
         })
         .catch((err) => {
          unsetLocalStorage()
          dispatch(push(`/login`))
    })
  }
}

export const logout = () => {
  return dispatch => {
    axios.post(`${Api}/logout`, { token: localStorage.getItem('token')})
      .then((response) => {
        unsetLocalStorage()
        dispatch(push('/login'))
      })
      .catch((err) => {
        console.log(`error logging out`)
      })
  }
}


// WEBPACK FOOTER //
// ./src/modules/auth.js